import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { AppState } from '@nxsys/store';
import { Rate } from '@nxsys/types/models/timesheet';
import { showCurrencyByCountry } from '@nxsys/utils';
import { formatMoney } from '@nxsys/utils/number-helper';
import { ColumnsType } from 'antd/lib/table';
import { toNumber } from 'lodash';
import { useSelector } from 'react-redux';
import AppCard from '../AppCard';
import AppTableContainer from '../AppTableContainer';
import { Tag } from 'antd';

type RateType = Partial<Rate>;

type AppRateTableProps = {
  data: RateType[];
  listHidden?: (
    | 'rateCode'
    | 'rateType'
    | 'description'
    | 'rate'
    | 'vatDetails'
    | 'units'
    | 'net'
    | 'total'
  )[];
};

const AppRateTable = ({ data, listHidden = [] }: AppRateTableProps) => {
  const { messages } = useTypedIntl();
  const { payrollCountry } = useSelector((state: AppState) => state.appStore);

  const columns: ColumnsType<RateType> = [
    {
      key: 'rateCode',
      title: messages['assignment.rate.rateCode'],
      dataIndex: 'rateCode',
      hidden: listHidden.includes('rateCode'),
      render: (value: string) => <Tag>{value}</Tag>,
    },
    {
      key: 'rateType',
      title: messages['assignment.rate.type'],
      dataIndex: 'rateType',
      hidden: listHidden.includes('rateType'),
    },
    {
      key: 'description',
      title: messages['assignment.rate.description'],
      dataIndex: 'description',
      hidden: listHidden.includes('description'),
    },
    {
      key: 'rate',
      title: messages['assignment.rate.rate'],
      dataIndex: 'rate',
      render: (rate: string) =>
        formatMoney(toNumber(rate), showCurrencyByCountry(payrollCountry)),
      hidden: listHidden.includes('rate'),
    },
    {
      key: 'units',
      title: messages['assignment.rate.units'],
      dataIndex: 'units',
      hidden: listHidden.includes('units'),
    },
    {
      key: 'net',
      title: messages['assignment.rate.net'],
      dataIndex: 'net',
      hidden: listHidden.includes('net'),
      render: (rate: string) =>
        formatMoney(toNumber(rate), showCurrencyByCountry(payrollCountry)),
    },
    {
      key: 'vatDetails',
      title: messages['assignment.rate.vatRate'],
      dataIndex: 'vatDetails',
      hidden: listHidden.includes('vatDetails'),
    },
    {
      key: 'total',
      title: messages['assignment.rate.total'],
      dataIndex: 'total',
      hidden: listHidden.includes('total'),
      render: (rate: string) =>
        formatMoney(toNumber(rate), showCurrencyByCountry(payrollCountry)),
    },
  ];

  return (
    <AppCard
      title={messages['assignment.section.rates'] ?? 'Rates'}
      style={{ marginTop: 16 }}
    >
      <div style={{ padding: 20 }}>
        <AppTableContainer
          data={data ?? []}
          columns={columns}
          loading={false}
          pagination={false}
          page={0}
          total={data?.length ?? 0}
          pageSize={0}
          scroll={{ x: 1500, y: 700 }}
        />
      </div>
    </AppCard>
  );
};

export default AppRateTable;
